import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-white text-gray-500 border-t border-gray-200 py-2 mt-10 w-full text-xs">
      <div className="w-full px-4 space-y-0.5 leading-tight text-left">
      <p className="flex space-x-4 font-bold">
  <span className="hover:text-blue-500 cursor-pointer transition-colors duration-200">제휴문의</span>
  <span
            className="hover:text-blue-500 cursor-pointer transition-colors duration-200"
            onClick={() => navigate('/policy/TOS')}
          >
            이용약관
          </span>
  <span className="hover:text-blue-500 cursor-pointer transition-colors duration-200">개인정보처리방침</span>
  <span className="hover:text-blue-500 cursor-pointer transition-colors duration-200">공지사항</span>
</p>
        <br/>
        <p>바통플랫폼 | info@bin-go.kr | 070-7771-9009 | 371-43-00646</p>
      </div>
    </footer>
  );
};

export default Footer;